import React, { Component } from 'react';
import { Translate } from 'react-localize-redux';

export class RatioBookBodyItem {
    constructor(year, item) {
        this.year = year;
        this.item = item;
        this.t1_dk = 0; this.t2_dk = 0; this.t3_dk = 0; this.t4_dk = 0;
        this.t1_me = 0; this.t2_me = 0; this.t3_me = 0; this.t4_me = 0;
        this.t1_hk = 0; this.t2_hk = 0; this.t3_hk = 0; this.t4_hk = 0;

        this.a1_dk = ""; this.a1_me = ""; this.a1_hk = "";
        this.a2_dk = ""; this.a2_me = ""; this.a2_hk = "";
        this.a3_dk = ""; this.a3_me = ""; this.a3_hk = "";

        this.o1_dk = ""; this.o2_dk = ""; this.o3_dk = "";
        this.o1_me = ""; this.o2_me = ""; this.o3_me = "";
        this.o1_hk = ""; this.o2_hk = ""; this.o3_hk = "";

        this.name = item.description;
        this.unit = item.unit;
    }

    getData(row) {
        const item = this.item;
        for (let i = 0; i < item.data.length; i++) {
            if (item.data[i].type == "T1" && item.data[i].year == this.year - 3) {
                this.t1_dk = item.data[i].dk
                this.t1_me = item.data[i].me
                this.t1_hk = item.data[i].hk
            }
            if (item.data[i].type == "T1" && item.data[i].year == this.year - 2) {
                this.t2_dk = item.data[i].dk;
                this.t2_me = item.data[i].me;
                this.t2_hk = item.data[i].hk;
            }
            if (item.data[i].type == "T1" && item.data[i].year == this.year - 1) {
                this.t3_dk = item.data[i].dk;
                this.t3_me = item.data[i].me;
                this.t3_hk = item.data[i].hk;
            }
            if (item.data[i].type == "T1" && item.data[i].year == this.year) {
                this.t4_dk = item.data[i].dk;
                this.t4_me = item.data[i].me;
                this.t4_hk = item.data[i].hk;
            }
            if (item.data[i].type == "A1" && item.data[i].year == this.year) {
                this.a1_dk = !item.data[i].isNullOrUndefined && item.data[i].dk != 0 ? item.data[i].dk : "";
                this.a1_me = !item.data[i].isNullOrUndefined && item.data[i].dk != 0 ? item.data[i].me : "";
                this.a1_hk = !item.data[i].isNullOrUndefined && item.data[i].dk != 0 ? item.data[i].hk : "";
            }
            if (item.data[i].type == "A2" && item.data[i].year == this.year) {
                this.a2_dk = !item.data[i].isNullOrUndefined && item.data[i].dk != 0 ? item.data[i].dk : "";
                this.a2_me = !item.data[i].isNullOrUndefined && item.data[i].dk != 0 ? item.data[i].me : "";
                this.a2_hk = !item.data[i].isNullOrUndefined && item.data[i].dk != 0 ? item.data[i].hk : "";
            }
            if (item.data[i].type == "A3" && item.data[i].year == this.year) {
                this.a3_dk = !item.data[i].isNullOrUndefined && item.data[i].dk != 0 ? item.data[i].dk : "";
                this.a3_me = !item.data[i].isNullOrUndefined && item.data[i].dk != 0 ? item.data[i].me : "";
                this.a3_hk = !item.data[i].isNullOrUndefined && item.data[i].dk != 0 ? item.data[i].hk : "";
            }
            if (item.data[i].type == "O1" && item.data[i].year == this.year) {
                this.o1_dk = !item.data[i].isNullOrUndefined && item.data[i].dk != 0 ? item.data[i].dk : "";
                this.o1_me = !item.data[i].isNullOrUndefined && item.data[i].dk != 0 ? item.data[i].me : "";
                this.o1_hk = !item.data[i].isNullOrUndefined && item.data[i].dk != 0 ? item.data[i].hk : "";
            }
            if (item.data[i].type == "O2" && item.data[i].year == this.year) {
                this.o2_dk = !item.data[i].isNullOrUndefined && item.data[i].dk != 0 ? item.data[i].dk : "";
                this.o2_me = !item.data[i].isNullOrUndefined && item.data[i].dk != 0 ? item.data[i].me : "";
                this.o2_hk = !item.data[i].isNullOrUndefined && item.data[i].dk != 0 ? item.data[i].hk : "";
            }
            if (item.data[i].type == "O3" && item.data[i].year == this.year) {
                this.o3_dk = !item.data[i].isNullOrUndefined && item.data[i].dk != 0 ? item.data[i].dk : "";
                this.o3_me = !item.data[i].isNullOrUndefined && item.data[i].dk != 0 ? item.data[i].me : "";
                this.o3_hk = !item.data[i].isNullOrUndefined && item.data[i].dk != 0 ? item.data[i].hk : "";
            }
        }
        this.Name = item.name;
        this.Unit = item.unit;
    }

    renderBodyItem(key) {
        const dk = <Translate id="RatioBook.Common.DK" options={{ renderInnerHtml: true }} />
        const hk = <Translate id="RatioBook.Common.HK" options={{ renderInnerHtml: true }} />
        const me = <Translate id="RatioBook.Common.Me" options={{ renderInnerHtml: true }} />

        return (
            <React.Fragment key={key}>
                {this.renderBodyItemRow(key, dk, me, hk)}
            </React.Fragment>
        )
    }

    renderBodyItemRow(key, dk, me, hk) {
        this.getData();
        return (
            <React.Fragment>
                <tr>
                    <td className="right">{this.t1_dk}</td>
                    <td className="right">{this.t2_dk}</td>
                    <td className="right">{this.t3_dk}</td>
                    <td className="right">{this.t4_dk}</td>
                    <td rowSpan="3">{this.name}</td>
                    <td className="center">{dk}</td>
                    <td rowSpan="3">{this.unit}</td>
                    <td className="right">{this.a1_dk}</td>
                    <td className="right">{this.a2_dk}</td>
                    <td className="right">{this.a3_dk}</td>
                    <td className="right">{this.o1_dk}</td>
                    <td className="right">{this.o2_dk}</td>
                    <td className="right">{this.o3_dk}</td>
                </tr>
                <tr>
                    <td className="right">{this.t1_me}</td>
                    <td className="right">{this.t2_me}</td>
                    <td className="right">{this.t3_me}</td>
                    <td className="right">{this.t4_me}</td>
                    <td className="center">{me}</td>
                    <td className="right">{this.a1_me}</td>
                    <td className="right">{this.a2_me}</td>
                    <td className="right">{this.a3_me}</td>
                    <td className="right">{this.o1_me}</td>
                    <td className="right">{this.o2_me}</td>
                    <td className="right">{this.o3_me}</td>
                </tr>
                <tr>
                    <td className="right">{this.t1_hk}</td>
                    <td className="right">{this.t2_hk}</td>
                    <td className="right">{this.t3_hk}</td>
                    <td className="right">{this.t4_hk}</td>
                    <td className="center">{hk}</td>
                    <td className="right">{this.a1_hk}</td>
                    <td className="right">{this.a2_hk}</td>
                    <td className="right">{this.a3_hk}</td>
                    <td className="right">{this.o1_hk}</td>
                    <td className="right">{this.o2_hk}</td>
                    <td className="right">{this.o3_hk}</td>
                </tr>
            </React.Fragment>
        )
    }
}

export class RatioBookRender {
    constructor(year, header, labels, data) {
        this.year = year;
        this.header = header;
        this.labels = labels;
        this.data = data;
        this.t1 = 0;
        this.t2 = 0;
        this.t3 = 0;
        this.t4 = 0;
        this.a1 = 0;
        this.a2 = 0;
        this.a3 = 0;
        this.o1 = 0;
        this.o2 = 0;
        this.o3 = 0;
    }

    renderTitle() {
        return (
            < h2 > <br />
                <strong>
                    {<Translate id="RatioBook.Common.ReportType" options={{ renderInnerHtml: true }} />}
                    {`: ${this.data.okec} - ${this.data.title}`}
                </strong>
                <br /> <br />
            </h2 >
        );
    }

    renderHeader() {
        for (let i = 0; i < this.header.length; i++) {
            if (this.header[i].type == "T1" && this.header[i].year == this.year - 3)
                this.t1 = this.header[i].value;
            if (this.header[i].type == "T1" && this.header[i].year == this.year - 2)
                this.t2 = this.header[i].value;
            if (this.header[i].type == "T1" && this.header[i].year == this.year - 1)
                this.t3 = this.header[i].value;
            if (this.header[i].type == "T1" && this.header[i].year == this.year)
                this.t4 = this.header[i].value;

            if (this.header[i].type == "A1" && this.header[i].year === this.year) this.a1 = this.header[i].value;
            if (this.header[i].type == "A2" && this.header[i].year === this.year) this.a2 = this.header[i].value;
            if (this.header[i].type == "A3" && this.header[i].year === this.year) this.a3 = this.header[i].value;
            if (this.header[i].type == "O1" && this.header[i].year === this.year) this.o1 = this.header[i].value;
            if (this.header[i].type == "O2" && this.header[i].year === this.year) this.o2 = this.header[i].value;
            if (this.header[i].type == "O3" && this.header[i].year === this.year) this.o3 = this.header[i].value;

        }

        return (
            <React.Fragment>
                <tr>
                    <td className="right">{this.t1}</td>
                    <td className="right">{this.t2}</td>
                    <td className="right">{this.t3}</td>
                    <td className="right">{this.t4}</td>
                    <td>{<Translate id="RatioBook.Common.BusinessSubjects" options={{ renderInnerHtml: true }} />}</td>
                    <td></td>
                    <td>{<Translate id="RatioBook.Common.Count" options={{ renderInnerHtml: true }} />}</td>
                    <td className="right">{this.a1}</td>
                    <td className="right">{this.a2}</td>
                    <td className="right">{this.a3}</td>
                    <td className="right">{this.o1}</td>
                    <td className="right">{this.o2}</td>
                    <td className="right">{this.o3}</td>
                </tr>
            </React.Fragment>
        );
    }

    renderLabels() {
        return (
            <React.Fragment>
                <tr>
                    <th rowSpan="2" className="right">{this.year - 3}</th>
                    <th rowSpan="2" className="right">{this.year - 2}</th>
                    <th rowSpan="2" className="right">{this.year - 1}</th>
                    <th rowSpan="2" className="right">{this.year}</th>
                    <th rowSpan="2" >{<Translate id="RatioBook.Common.Ratio" options={{ renderInnerHtml: true }} />}</th>
                    <th rowSpan="2" className="center">{<Translate id="RatioBook.Common.StatChar" options={{ renderInnerHtml: true }} />}</th>
                    <th rowSpan="2" className="center">{<Translate id="RatioBook.Common.Unit" options={{ renderInnerHtml: true }} />}</th>
                    <th colSpan="3" className="center">{<Translate id="RatioBook.Common.AssetsInMilSk" options={{ renderInnerHtml: true }} />}</th>
                    <th colSpan="3" className="center">{<Translate id="RatioBook.Common.TurnoverInMilSk" options={{ renderInnerHtml: true }} />}</th>
                </tr>
                <tr>
                    <th className="center"> &lt;&nbsp;1,6 </th>
                    <th className="center">1,6-5,0</th>
                    <th className="center">&gt;&nbsp;5,0</th>
                    <th className="center">&lt;&nbsp;0,8</th>
                    <th className="center">&lt;&nbsp;0,8-3,3</th>
                    <th className="center">&gt;&nbsp;3,3</th>
                </tr>
            </React.Fragment >
        );
    }
}

